import * as React from 'react';
import { useState } from 'react';
import { IItemSuggestion } from './types';
import Button from './Button';
import LoadingIcon from '../Shared/LoadingIcon';
import { createItemPath } from './helpers';

interface IProps {
  label: string;
  keyword: string;
  selectedSuggestion: IItemSuggestion;
  disabled: boolean;
}

const ItemSubmitButton: React.FC<IProps> = (props) => {
  const [isLoading, setLoading] = useState<boolean>(false);
  const { label, selectedSuggestion, disabled } = props;
  const path = createItemPath(selectedSuggestion);

  let isActive = true;
  if (path.length <= 1) {
    isActive = false;
  }

  function handleClick() {
    if (!isActive) {
      alert('Please select destination.');
      return;
    }

    setLoading(true);
    window.location.href = path.join('');
  }

  return (
    <Button type="submit" onClick={handleClick} disabled={(isLoading ? true : (disabled ? true : false))}>
      {isLoading ? <LoadingIcon /> : label}
    </Button>
  );
}

export default ItemSubmitButton;
